const initialState = {
  isFetching: false,
  isFetched: false,
  info: null,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'MARKETPLACE/SAVE_ITEM_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/SAVE_ITEM_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/SAVE_ITEM_SUCCESS':
      return { ...state, isFetching: false, isFetched: true };

    case 'MARKETPLACE/DETAIL_ITEM_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/DETAIL_ITEM_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/DETAIL_ITEM_SUCCESS':
      return { ...state, isFetching: false, isFetched: true, info: { ...payload.marketplace } };

    case 'MARKETPLACE/PAY_ITEM_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/PAY_ITEM_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/PAY_ITEM_SUCCESS':
      return { ...state, isFetching: false, isFetched: true };

    case 'MARKETPLACE/UPGRADE_ITEM_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/UPGRADE_ITEM_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/UPGRADE_ITEM_SUCCESS':
      return { ...state, isFetching: false, isFetched: true };

    case 'MARKETPLACE/RESET', 'MARKETPLACE/RESET_ITEM':
      return initialState;
    default:
      return state;
  };
};

export default reducer;